import {format} from 'date-fns';

export default {
  filters: {
    date(value) {
      return format(new Date(value), 'dd MMM yyyy');
    },
    datetime(value) {
      return format(new Date(value), 'dd MMM yyyy HH:mm');
    }
  }
};
